import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
const adminApi = axios.create({ baseURL: `${BASE}/api` });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('rmp_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && localStorage.getItem('rmp_admin_token')) {
      localStorage.removeItem('rmp_admin_token');
      if (!window.location.pathname.includes('/gestore/login')) {
        window.location.href = '/gestore/login';
      }
    }
    return Promise.reject(err);
  }
);

export default adminApi;
